
import { Table } from '@tiptap/extension-table';
import {CustomTableView} from './CustomTableView';
const CustomTable = Table.extend({
    addOptions() {
        return {
            HTMLAttributes: {},
            resizable: true,
            handleWidth: 5,
            cellMinWidth: 25,
            View: CustomTableView,
            lastColumnResizable: false,
            allowTableNodeSelection: true,
        }
    },
    addAttributes() {
        return {
            ...this.parent?.(),
            class: {
                default: "cke_show_border general-convert-to-table table-border-solid",
                // Customize the HTML parsing
                parseHTML: element => element.getAttribute('class'),
                // … and customize the HTML rendering
                renderHTML: attributes => {
                    if (attributes.class) {
                        return {
                            'class': attributes.class
                        }
                    }
                },
            },
            width: {
                default: '100%'
            },
            "border-style": {
                default : "1",
                parseHTML: element => element.getAttribute('border-style'),
                // … and customize the HTML rendering
                renderHTML: attributes => {
                    if (attributes["border-style"]) {
                        return {
                            'border-style': attributes["border-style"]
                        }
                    }
                },
            },
            "border-radius": {
                default : "0",
                parseHTML: element => element.getAttribute('border-radius'),
                // … and customize the HTML rendering
                renderHTML: attributes => {
                    if (attributes["border-radius"]) {
                        return {
                            'border-radius': attributes["border-radius"]
                        }
                    }
                },
            },
            style: {
                default : null,
                parseHTML: element => element.getAttribute('style'),
                // … and customize the HTML rendering
                renderHTML: attributes => {
                    if (attributes["style"]) {
                        return {
                            'style': attributes["style"]
                        }
                    }
                },
            },
            uuid: {
                default : null,
                parseHTML: element => element.getAttribute('uuid'),
                // … and customize the HTML rendering
                renderHTML: attributes => {
                    if (attributes["uuid"]) {
                        return {
                            'uuid': attributes["uuid"]
                        }
                    }
                },
            }
        }
    },
});

export default CustomTable;